import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import Icon from '../icon/Icon';
import P from '../containers/Paragraph';
import { TranslatedCopy } from '../../intl/TranslatedCopy';

import { purchaseOptionTypes } from '../../types/products';

import { PRODUCT_ATTRIBUTE_SILHOUETTE } from '../../shop/constants';

const PurchaseOptionInfo = ({ purchaseOptions, silhouette, silhouetteType }) => (
  <>
    {purchaseOptions &&
      purchaseOptions.length > 0 &&
      purchaseOptions.map(option => {
        const unitLeftToPurchase = parseInt(option.minimumUnitsRequired, 10) - parseInt(option.totalUnitsPurchased, 10);
        return (
          <div
            key={option.purchaseOptionId}
            className='pdp__info_options flex-container row align-center pt2-sm pb2-sm prl3-sm mb4-sm'
          >
            <div className='gridwall__card_icon'>
              <Icon
                className='mr2-sm'
                name='filled-dollar'
                alt={new TranslatedCopy({ id: 'global.purchaseOptions' }).toString()}
              />
            </div>
            <P className='lh16-sm'>
              <TranslatedCopy
                id='allotments.sidebar.details.purchase.details'
                values={{
                  get: option.amountBuy,
                  buy: option.amountFree,
                  description:
                    option.unitAttributeName === PRODUCT_ATTRIBUTE_SILHOUETTE
                      ? silhouette.description
                      : silhouetteType.description,
                  left: unitLeftToPurchase < 0 ? 0 : unitLeftToPurchase
                }}
              />
            </P>
          </div>
        );
      })}
  </>
);

PurchaseOptionInfo.defaultProps = {
  purchaseOptions: null,
  silhouette: null,
  silhouetteType: null
};

PurchaseOptionInfo.propTypes = {
  purchaseOptions: PropTypes.arrayOf(purchaseOptionTypes),
  silhouette: PropTypes.shape({
    code: PropTypes.string,
    description: PropTypes.string
  }),
  silhouetteType: PropTypes.shape({
    code: PropTypes.string,
    description: PropTypes.string
  })
};

export default PurchaseOptionInfo;
